import { useEffect, useRef } from 'react';

export const useMultiAutoFocus = <T extends HTMLElement = HTMLElement>(keys: string[] = [], enabled?: boolean) => {
  const refMap = useRef(new Map<string, T | null>());

  const setRef = (key: string) => (el: T | null) => {
    refMap.current.set(key, el);
  };

  const focusFirstInteractive = (key: string) => {
    const el = refMap.current.get(key);
    const focusable = el?.querySelector<HTMLElement>(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    focusable?.focus();
  };

  useEffect(() => {
    if (!enabled) return;

    const frame = requestAnimationFrame(() => {
      keys.forEach((key) => focusFirstInteractive(key));
    });

    return () => cancelAnimationFrame(frame);
  }, [enabled, keys.join(',')]);

  const refs: Record<string, (el: T | null) => void> = {};
  keys.forEach((key) => {
    refs[key] = setRef(key);
  });

  return [refs, focusFirstInteractive] as const;
};
